import { GetRequest, PostRequest, PutRequest } from "../service"

const ControllerName = "Request"

export const GetAllMedicalRequests = (link) => {
    return GetRequest(ControllerName + '/' + link)
}

export const GetMedicalRequestDetails = (id) => {
    return GetRequest(`${ControllerName}/${id}`)
}

export const GetMedicalReqDetails = (id) => {
    return GetRequest(`${ControllerName}/getDetails/${id}`)
}


export const UpdateMedicalRequestData = (id, body) => {
    return PutRequest(`${ControllerName}/${id}`, body)
}

export const PostMedicalRequestData = (id, body) => {
    return PostRequest(`${ControllerName}/${id}`, body)
}

export const PostPricingQuotation = (body) => {
    return PutRequest(`${ControllerName}`, body)
}